import React from "react";
import { Tag } from "antd";
import { getTextColorBasedOnBg } from "@utils/color_utils";
import { FLAG_FALLBACK_COLOR } from "../mappers/coachTag.mapper";

// Pure — one selectable flag, carrying the flag's own colour. Selected fills with it and takes
// whichever of black or white reads on top; unselected outlines in it. Either way the colour is
// what identifies the flag, matching the dot beside it in the cell tooltips.
const filledStyle = (color) => ({ backgroundColor: color, borderColor: color, color: getTextColorBasedOnBg(color) });

// Pure — a flag as a filled tag that cannot be clicked (the selected FlagTag look), for read-only
// lists. A name too long for its column ends in an ellipsis, with the full name on hover.
export const FlagLabel = ({ flag }) => (
    <Tag
        className="stv2-flag-tag stv2-flag-label"
        style={filledStyle(flag.color || FLAG_FALLBACK_COLOR)}
        title={flag.name}
    >
        {flag.name}
    </Tag>
);

export const FlagTag = ({ flag, selected, onSelect, onToggle }) => {
    const color = flag.color || FLAG_FALLBACK_COLOR;
    return (
        <Tag.CheckableTag
            checked={selected}
            // Single select by default: clicking the chosen tag again is a no-op, so a stray click
            // cannot clear the selection. With `onToggle` (multi select), every click flips it.
            onChange={(checked) => (onToggle ? onToggle(flag.id, checked) : checked && onSelect(flag.id))}
            className="stv2-flag-tag"
            style={selected ? filledStyle(color) : { backgroundColor: "transparent", borderColor: color, color }}
        >
            {flag.name}
        </Tag.CheckableTag>
    );
};
